import { RecordsNotFoundMessage } from '@modules/common/components/RecordsNotFoundMessage';
import { Paper, Stack } from '@mui/material';

export function SearchResultsNotFoundMessage() {
  return (
    <Stack direction="column" alignItems="center">
      <Paper
        variant="outlined"
        sx={{
          mt: 7,
          borderRadius: 3,
          width: 660,
          height: 380,
        }}
      >
        <RecordsNotFoundMessage iconSize={114} titleVariant="h4" />
      </Paper>
    </Stack>
  );
}
